export default __webpack_public_path__ + "static/media/ct-logo.f6275e98.svg";